
import { useContext } from 'react';
import { WorkItemPermissionsContext } from 'components/work-items';

const useWorkItemPermissions = () => useContext(WorkItemPermissionsContext);

export default useWorkItemPermissions;